import type {APITaskInput} from '../types/api-task'
import type {UITask} from '../types/task'
import type {SidebarChat} from '../types/sidebar-chat'
import type {TaskRepoGroup} from '../hooks/use-grouped-tasks'

export const agentTaskPinsQueryKey = ['agent-task-pins']

export interface TaskPin {
  type: 'task'
  pinned_at: string
  task: APITaskInput
}

export function taskPinApiPath(taskId: string) {
  return `/agents/tasks/${encodeURIComponent(taskId)}/pin`
}

export function parseTaskPins(value: unknown): TaskPin[] {
  if (!value || typeof value !== 'object' || !('items' in value) || !Array.isArray(value.items)) {
    throw new Error('Invalid pinned sessions response')
  }
  return value.items.flatMap((item: unknown) => {
    if (!item || typeof item !== 'object' || !('type' in item) || typeof item.type !== 'string') {
      throw new Error('Invalid pinned session')
    }
    if (item.type !== 'task') return []
    if (
      !('pinned_at' in item) ||
      typeof item.pinned_at !== 'string' ||
      !('task' in item) ||
      !item.task ||
      typeof item.task !== 'object' ||
      !('id' in item.task) ||
      typeof item.task.id !== 'string'
    ) {
      throw new Error('Invalid pinned session')
    }
    return [item as TaskPin]
  })
}

export function excludePinnedSidebarRows(
  tasks: readonly UITask[] | undefined,
  groups: readonly TaskRepoGroup[] | undefined,
  chats: readonly SidebarChat[] | undefined,
  pinnedIds: ReadonlySet<string>,
) {
  if (pinnedIds.size === 0) return {tasks, groups, chats}
  return {
    tasks: tasks?.filter(task => !task.id || !pinnedIds.has(task.id)),
    groups: groups?.flatMap(([key, groupTasks]) => {
      const remaining = groupTasks.filter(task => !task.id || !pinnedIds.has(task.id))
      return remaining.length ? [[key, remaining] as const] : []
    }),
    chats: chats?.filter(chat => chat.legacy || !pinnedIds.has(chat.taskId)),
  }
}
